import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "react-quill/dist/quill.snow.css";
import "../../styles/accountdetails.css";
import expertDefaultImg from "../../images/expert-default.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import ZohoButtons from "../../components/AccountDetails/zohoButton";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import POSingleProject from "../ProjectsOverview/POSingleProject";
import ClientLogo from "../../components/AccountDetails/ClientLogo";
import { UrlContext } from "../../contexts/UrlContext";
import ProjectGantt from "../AccountDetails/ProjectGantt";
// import LoadingIcon from '../../images/Loading_icon.gif'

export const UserContextClient = createContext();

export default function AccountDetails() {
  useEffect(() => {
    document.title = "Account Details";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const [accessUser, setAccessUser] = useState(null);
  const id = useParams().id;
  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [projectData, setProjectData] = useState(null);
  const [clientCity, setClientCity] = useState("");
  const [clientCountry, setClientCountry] = useState("");
  const [clientLogo, setClientLogo] = useState("");
  const [clientID, setClientID] = useState("");
  const [clientMSA, setClientMSA] = useState("");
  const [shareProfileName, setShareProfileName] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exCurrency, setExCurrency] = useState("EUR");
  const [hourlyRate, setHourlyRate] = useState("1100");
  const [hourlyRateReturnSuccess, setHourlyRateReturnSuccess] = useState(false);
  const [hourlyRateReturnError, setHourlyRateReturnError] = useState(false);
  const [hourlyRateLoading, setHourlyRateLoading] = useState(false);

  useEffect(() => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}account-details/` + id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setData(data.account);
        setClientCity(data.account.clientCity);
        setClientCountry(data.account.clientCountry);
        setClientMSA(data.account.MSA);
        setShareProfileName(data.account.shareProfileName);
        setClientLogo(data.account.clientLogo);
        setClientID(data.account.clientID);
        setProjectData(data.project);
        if (data.account.clientCurrency) {
          setExCurrency(data.account.clientCurrency);
        }
        if (data.account.clientRate) {
          setHourlyRate(data.account.clientRate);
        }
        if (users.length === 0) {
          setUsers(data.user_list);
        }
        // setImage({preview: data.clientLogo})
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  const saveExCurrency = (exCurrency) => {
    setHourlyRateReturnError(false);
    setHourlyRateLoading(true);
    console.log(clientID);
    const url = `${API_URL}save-client-currency`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ currency: exCurrency, clientID: data.id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setHourlyRateLoading(false);
        if (data.status === "success") {
          setHourlyRateReturnSuccess(true);
          setTimeout(() => {
            setHourlyRateReturnSuccess(false);
          }, 1500);
          // setBackupData(
          //   backupData.map((item) => {
          //     if (item.expertID === expert_id) {
          //       item.projectCurrency = exCurrency;
          //     }
          //     return item;
          //   })
          // );
        } else {
          setHourlyRateReturnError(true);
        }
      })
      .catch((err) => {
        setHourlyRateLoading(false);
        setHourlyRateReturnError(true);
      });
  };

  const saveHourlyRateChange = () => {
    setHourlyRateReturnError(false);
    setHourlyRateLoading(true);
    const url = `${API_URL}update-client-hourly-rate`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ hourly_rate: hourlyRate, clientID: data.id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setHourlyRateLoading(false);
        if (data.status === "success") {
          setHourlyRateReturnSuccess(true);
          setTimeout(() => {
            setHourlyRateReturnSuccess(false);
          }, 1500);
        } else {
          setHourlyRateReturnError(true);
        }
      })
      .catch((err) => {
        setHourlyRateLoading(false);
        setHourlyRateReturnError(true);
      });
  };

  const changeValue = (newValue) => {
    // console.log(newValue.id)
    // setReturnError(false)
    // setLoading(true)
    setReturnError(false);
    setLoading(true);
    var url = "";
    if (newValue.id === "clientCity") {
      url = `${API_URL}change-city`;
    } else if (newValue.id === "clientCountry") {
      url = `${API_URL}change-country`;
    } else if (newValue.id === "clientMSA") {
      url = `${API_URL}change-msa`;
    } else if (newValue.id === "upload-button") {
      url = `${API_URL}change-clientLogo`;
    } else if (
      newValue.id == "customSwitch1-accountSetting-enableProfileNameShare"
    ) {
      url = `${API_URL}change-shareProfileName`;
      setShareProfileName(newValue.checked ? "yes" : "");
    }

    var updatedData = {};
    if (newValue.id === "upload-button") {
      updatedData = {
        id: data.id,
        value: data.image,
      };
    } else if (
      newValue.id === "customSwitch1-accountSetting-enableProfileNameShare"
    ) {
      updatedData = {
        id: data.id,
        value: newValue.checked ? "yes" : "",
      };
    } else {
      updatedData = {
        id: data.id,
        value: newValue.value,
      };
    }
    // console.log(updatedData);
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          window.location.reload();
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setReturnError(true);
        console.log(err);
      });
  };

  const readFile = (file) => {
    return new Promise((resolve, reject) => {
      var fr = new FileReader();
      fr.readAsDataURL(file);
      fr.onload = () => {
        resolve(fr.result);
      };
      fr.onerror = reject;
      //   fr.readAsText(file.blob);
    });
  };

  const handleChangePhoto = (e) => {
    if (e.target.files.length) {
      readFile(e.target.files[0])
        .then((result) => result)
        .then((imgData) => {
          setClientLogo(imgData);
          const url = `${API_URL}change-clientLogo`;
          const updatedData = {
            id: data.id,
            value: imgData,
          };

          fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedData),
          })
            .then((res) => res.json())
            .then((data) => {})
            .catch((err) => {
              //   setReturnError(true)
              console.log(err);
            });
        });

      // var file64 = ''
      // let reader = new FileReader();
      // reader.readAsDataURL(e.target.files[0]);
      // reader.onload = () => {
      //    setClientLogo(reader.result)
      //    setImage({
      //       file: reader.result,
      //       preview: URL.createObjectURL(e.target.files[0])
      //     });
      // }
    }
    // console.log(image)
    // console.log(clientLogo)
    // changeValue(e.target)
  };

  return (
    <UserContextClient.Provider value={accessUser}>
      {data ? (
        <div className="body-container">
          <section id="content">
            <div className="page-heading">
              <div
                className="clearfix"
                style={{ position: "relative", marginBottom: "40px" }}
              >
                <div
                  className="media-left pr30"
                  style={{ float: "left", paddingRight: "16px" }}
                >
                  <center
                    className="container"
                    style={{ position: "relative", paddingLeft: "10px" }}
                  >
                    <ClientLogo
                      client_id={data.id}
                      exLogo1={clientLogo}
                      setExLogo1={setClientLogo}
                    />
                  </center>
                  <div
                    className="panel"
                    style={{ width: "450px", marginLeft: "-17px" }}
                  >
                    {/* <div className="panel-heading">
                           <span className="panel-title">Rating</span>
                           <span className="panel-icon">
                              <i className="fa fa-star" />
                              <i className="fa fa-star" />
                              <i className="fa fa-star" />
                              <i className="fa fa-star" />
                              <i className="fa fa-star" /> 5/5
                           </span>
                        </div> */}
                    <div
                      className="panel-body pn"
                      style={{ padding: "0 15px 10px 15px" }}
                    >
                      <table className="table table-right mbn tc-icon-1 tc-med-2 tc-bold-last">
                        <tbody>
                          <tr>
                            <td className="tdIcons paddingNone">
                              <i className="fa-solid fa-city" />
                            </td>
                            <td>Client City</td>
                            <td style={{ paddingRight: 0 }}>
                              <input
                                id="clientCity"
                                type="text"
                                placeholder="Client City"
                                value={clientCity}
                                onChange={(e) => {
                                  setClientCity(e.target.value);
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === data.clientCity)
                                    return;
                                  changeValue(e.target);
                                }}
                              />
                              {loading && (
                                <img
                                  className="return-msg-icon"
                                  style={{ top: "6px", right: "-17px" }}
                                  src={LoadingIcon}
                                  alt="loading"
                                  title="Loading..."
                                />
                              )}
                              {returnSuccess && (
                                <img
                                  className="return-msg-icon"
                                  style={{ top: "6px", right: "-17px" }}
                                  src={successIcon}
                                  alt="success"
                                  title="Success"
                                />
                              )}
                              {returnError && (
                                <img
                                  className="return-msg-icon"
                                  style={{ top: "6px", right: "-17px" }}
                                  src={errorIcon}
                                  alt="error"
                                  title="Error! Please reload"
                                />
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td className="tdIcons paddingNone">
                              <i className="fa-solid fa-globe" />
                            </td>
                            <td>Client Country</td>
                            <td style={{ paddingRight: 0 }}>
                              <input
                                id="clientCountry"
                                placeholder="Client Country"
                                value={clientCountry}
                                onChange={(e) => {
                                  setClientCountry(e.target.value);
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === data.clientCountry)
                                    return;
                                  changeValue(e.target);
                                }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="tdIcons paddingNone">
                              <i className="fa-solid fa-user" />
                            </td>
                            <td>Client Owner</td>
                            <td style={{ paddingRight: 0 }}>
                              <input
                                id="clientOwner"
                                placeholder="Client Owner"
                                value={data.clientOwner}
                                disabled
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="tdIcons paddingNone">
                              <i className="fa-solid fa-folder" />
                            </td>
                            <td>MSA</td>
                            <td style={{ paddingRight: 0 }}>
                              <select
                                id="clientMSA"
                                onChange={(e) => changeValue(e.target)}
                                value={clientMSA}
                              >
                                <option value="" selected>
                                  Select
                                </option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="tdIcons paddingNone"
                              style={{ borderTop: "1px solid #fff" }}
                            >
                              <i className="fa-solid fa-money-bill-1"></i>
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #fff",
                                paddingRight: "8px",
                              }}
                            >
                              Hourly rate
                            </td>
                            <td
                              className="position-relative"
                              style={{
                                borderTop: "1px solid #fff",
                                paddingRight: 0,
                              }}
                            >
                              <select
                                className="prj-summ-currency-daily"
                                value={exCurrency}
                                onChange={(e) => {
                                  setExCurrency(e.target.value);
                                  saveExCurrency(e.target.value);
                                }}
                              >
                                <option value="">---</option>
                                <option value="EUR">EUR</option>
                                <option value="USD">USD</option>
                                <option value="GBP">GBP</option>
                                <option value="CHF">CHF</option>
                                <option value="AUD">AUD</option>
                                <option value="AED">AED</option>
                                <option value="INR">INR</option>
                              </select>
                              <input
                                type="text"
                                className="exdetails-input2"
                                style={{ width: "110px", marginLeft: "5px" }}
                                value={hourlyRate}
                                placeholder="Add hourly rate"
                                onChange={(e) => {
                                  setHourlyRate(e.target.value);
                                }}
                                onBlur={saveHourlyRateChange}
                              />
                              {hourlyRateLoading && (
                                <img
                                  className="return-msg-icon"
                                  style={{ top: "16px", right: "0" }}
                                  src={LoadingIcon}
                                  alt="loading"
                                  title="Loading..."
                                />
                              )}
                              {hourlyRateReturnSuccess && (
                                <img
                                  className="return-msg-icon"
                                  style={{ top: "16px", right: "0" }}
                                  src={successIcon}
                                  alt="success"
                                  title="Success"
                                />
                              )}
                              {hourlyRateReturnError && (
                                <img
                                  className="return-msg-icon"
                                  style={{ top: "16px", right: "0" }}
                                  src={errorIcon}
                                  alt="error"
                                  title="Error! Please reload"
                                />
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td className="tdIcons paddingNone">
                              <i className="fa-solid fa-pencil" />
                            </td>
                            <td>
                              <div
                                class="custom-control custom-control-right custom-switch"
                                // style={{ paddingRight: "50px" }}
                              >
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="customSwitch1-accountSetting-enableProfileNameShare"
                                  checked={shareProfileName === "yes"}
                                  onChange={(e) => changeValue(e.target)}
                                />
                                <label
                                  class="custom-control-label"
                                  for="customSwitch1-accountSetting-enableProfileNameShare"
                                >
                                  Profile names to be shared
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="profile-actions">
                  {/* <UpdateFromLinkedin expertID={data?.id} /> */}
                  {/* <input type="file" accept=".docx" onChange={handleFileUpload} />
                     <ReactQuill theme='snow' value={htmlContent} onChange={setHtmlContent} />
                     <button onClick={handleSave}>Save Document</button> */}
                  <ZohoButtons data={data} />
                  {/* <AddToProject expertID={data?.id} btnName={' Add to project'} allProjects={projects}/> */}
                  {/* <MergeExperts /> */}
                  {/* <EditExpert data={data} count={count} setCount={setCount}/> */}
                  {/* <DeleteExpert expertID={data?.id} /> */}
                </div>
                <div className="media-body expert-basic">
                  <a href={data.link} target="_blank" rel="noopener noreferrer">
                    {data.clientName}
                  </a>
                  {/* <div style={{ color: "rgb(132, 130, 130)", fontSize: '14px', width: '770px' }}>
                        {data.clientLocation ? ( 
                           <span title="Location">{data.clientLocation}</span> 
                        ) : (
                           <span>Location not added</span>
                        )}
                        {data.clientOwner ? (
                           <span title="Owner"> | {data.clientOwner}</span>
                        ) : (
                           <span></span>
                        )}
                     </div> */}
                </div>
              </div>
            </div>
            <div>
                <ProjectGantt 
                  projectID={id}
                />
            </div>
            <div
              className="project-overview-table container-div"
              style={{ marginLeft: "-17px" }}
            >
              {projectData.map((project, index) => {
                return (
                  <POSingleProject
                    key={index}
                    project={project}
                    users={users}
                    filtering={false}
                    page={"AccountDetails"}
                  />
                );
              })}
            </div>
          </section>
        </div>
      ) : (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <img src={LoadingIcon} alt="Loading..." style={{ height: "50px" }} />
          <h4 style={{ marginTop: "20px" }}>please wait</h4>
        </div>
      )}
    </UserContextClient.Provider>
  );
}
